import React from 'react';

function Header() {
  return (
    <header className="bg-white border-b border-primary-200 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center">
        <img
          src="/focusgarden-logo.svg"
          alt="Focus Garden"
          className="h-9 md:h-11 w-auto"
          loading="eager"
        />
      </div>
    </header>
  );
}

export default Header;
